// extracted by mini-css-extract-plugin
module.exports = {"content":"content___7oBDn","reload-permission":"reload-permission___2A5Hl"};